import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import {Field} from "formik";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FormLabel from "@material-ui/core/FormLabel";
import {RadioGroup} from 'formik-material-ui';
import WhatsappSelect from '../utils/WhatsappSelect';
import {Calendar} from './Calendar';
import {CalendarToday} from '@material-ui/icons';
import CountrySelect from "../utils/CountrySelect";

export default function AddressForm({values, handleChange, errors, setFieldValue}) {
    return (
        <React.Fragment>
            <Typography variant="h6" gutterBottom>
                Datos del cliente
            </Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        id="firstName"
                        name="firstName"
                        label="Nombre"
                        value={values.firstName}
                        error={errors.firstName !== undefined}
                        onChange={handleChange}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        id="lastName"
                        name="lastName"
                        label="Apellido"
                        value={values.lastName}
                        error={errors.lastName !== undefined}
                        onChange={handleChange}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>

                    <CountrySelect menu={true} values={values} handleChange={handleChange} fullWidth={true}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        id="phoneNumber"
                        name="phoneNumber"
                        label="Whatsapp"
                        value={values.phoneNumber}
                        error={errors.phoneNumber !== undefined}
                        onChange={handleChange}
                        placeholder="Número de Whatsapp sin prefijo"
                        fullWidth

                    />
                </Grid>
                <Grid item xs={12}>
                    <Field component={RadioGroup} name="deliveryType">

                        <FormLabel component="legend">Tipo de envío</FormLabel>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={3} sm={6}>
                                <FormControlLabel
                                    value="retiro"
                                    name="deliveryType"
                                    control={<Radio/>}
                                    label="Retiro"
                                />
                            </Grid>
                            <Grid item xs={12} md={3} sm={6}>
                                <FormControlLabel
                                    value="delivery"
                                    name="deliveryType"
                                    control={<Radio/>}
                                    label="Delivery"
                                />
                            </Grid>
                            <Grid item xs={12} md={3} sm={6}>
                                <FormControlLabel
                                    value="consulta"
                                    name="deliveryType"
                                    control={<Radio/>}
                                    label="Consulta"
                                />
                            </Grid>
                            <Grid item xs={12} md={3} sm={6}>
                                <FormControlLabel
                                    value="programado"
                                    name="deliveryType"
                                    control={<Radio/>}
                                    label="Reserva/Programado"
                                />
                            </Grid>
                            <Grid item xs={12} md={3} sm={6}>
                                <FormControlLabel
                                    value="pedirEnMesa"
                                    name="deliveryType"
                                    control={<Radio/>}
                                    label="Pedir en mesa"
                                />
                            </Grid>
                        </Grid>
                    </Field>
                </Grid>

                {(values.deliveryType === 'delivery' || values.deliveryType === 'programado') &&
                <>
                    {values.deliveryType === 'programado' &&
                    <Calendar
                        setFieldValue={setFieldValue}
                    />
                    }
                    <Grid item xs={12}>
                        <TextField
                            required
                            id="address1"
                            name="address1"
                            label="Dirección 1"
                            value={values.address1}
                            onChange={handleChange}
                            placeholder="Apartamento / Edificio / Localidad"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="address2"
                            name="address2"
                            label="Dirección 2"
                            value={values.address2}
                            onChange={handleChange}
                            placeholder="Ciudad / Codigo Postal"
                            fullWidth
                        />
                    </Grid>
                </>
                }
                {(values.deliveryType === "pedirEnMesa") &&
                <Grid item xs={12}>
                    <TextField
                        id="numeroMesa"
                        name="numeroMesa"
                        label="Número de la mesa"
                        value={values.numeroMesa}
                        onChange={handleChange}
                        fullWidth
                    />
                </Grid>
                }

                <Grid item xs={12}>
                    <TextField
                        id="comment"
                        name="comment"
                        label="Comentario"
                        value={values.comment}
                        onChange={handleChange}
                        multiline
                        rows={2}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}